/* =========================================================
   PATHWAYS
========================================================= */

import React from "react";
import SectionHeader from "./SectionHeader";

const PathwaysSection = ({ data }) => (
    <section className="pathways" id="research">

        <div className="container">

            <SectionHeader
                title={data.title}
                description={data.description}
            />

            <div className="pathway-grid">

                {(data.items || []).map((item, i) => (
                    <div className="pathway" key={i}>

                        <div className="eyebrow">
                            {item.eyebrow}
                        </div>

                        <h3>{item.title}</h3>

                        <p>{item.description}</p>

                        <ul className="pathway-list">

                            {(item.items || []).map((x, j) => (
                                <li key={j}>{x}</li>
                            ))}

                        </ul>

                    </div>
                ))}

            </div>

        </div>

    </section>
);

export default PathwaysSection;